



























/* eslint-disable @typescript-eslint/no-var-requires */
// TODO: find out why import does not work
import { Component, Vue } from 'vue-property-decorator';

const flagDe = require('@/assets/flag-de.svg');
const flagEn = require('@/assets/flag-en.svg');

@Component({})
export default class LocaleSelector extends Vue {
  locales = [
    { iso: 'de', label: 'Deutsch', icon: flagDe },
    { iso: 'en', label: 'English', icon: flagEn },
  ];

  onLocaleChanged(newLocale: string) {
    this.$store.dispatch('setLocale', newLocale);
  }
}
